import gql from "graphql-tag";
const UPDATEPASSWORD = gql`
  mutation updatePassword($changePasswordInput: ChangePasswordInput!) {
    updatePassword(changePasswordInput: $changePasswordInput) {
        success,
        message,
        err
    }
  }
`;

export default UPDATEPASSWORD;
